import React, {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import axios from 'axios'
import _ from 'lodash'

import {Grid, Typography} from '@material-ui/core'
import "react-datepicker/dist/react-datepicker.css";

import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import loading_gif from '../../assets/img/loading.gif'

import {ServerConfig} from 'config'
import {Bar} from "@reactchartjs/react-chart.js";

function utc_timestamp_to_local_datetime_string(ts) {
  let date_string = new Date(ts).toLocaleDateString("en-US");
  let time_string = new Date(ts).toLocaleTimeString("en-US", {timeZoneName: "short"})

  return date_string + " " + time_string;
}


const plot_options = {
  responsive: true,
  maintainAspectRatio: false,
  legend: {
    display: false
  },
  elements: {
    point: {
      radius: 4,
      hitRadius: 10,
    }
  },
  scales: {
    yAxes: [
      {
        ticks: {
          stepSize: 1
        },
        type: 'linear',
        display: true,
        position: 'left',
        id: 'y-axis-1',
        //gridLines: {zeroLineColor: 'gray', color: 'rgba(128,128,128,0.3)', display: true}
      },
    ],
    xAxes: [{
      type: 'time',
      id: 'x-axis-1',
      ticks: {
        //fontColor: 'rgb(255,255,255)',
        display: true,
      },
      time: {
        unit: "month",
        displayFormats: {
          hour: 'MMM DD hh a',
          day: 'MMM DD',
          month: 'MMM YY',
          quarter: 'MMM YYYY DD',
        },
      },
      offset: false,
      //type: "category",
      gridLines: {zeroLineColor: 'gray', display: false}
    }]
  },
}

const CustomerStats = () => {
  const token = useSelector(state => state.auth.access_token)

  const [isLoading, setIsLoading] = useState(false);
  const [customerStats, setCustomerStats] = useState([])
  const [customerGraphData, setCustomerGraphData] = useState({datasets: []})


  async function fetchCustomerStats(token) {
    setIsLoading(true);

    const config = {headers: {'Content-Type': 'application/json'}}

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    const results = await axios.get(`${ServerConfig.SERVER_URL}/tenant/stats_customers`, config)

    setCustomerStats(results.data);

    let customer_graph_labels = Object.keys(results.data["per_date"]);
    let customer_graph_data = Object.values(results.data["per_date"]);

    let customer_graph_datasets = [
      {
        type: 'line',
        label: '#Signups',
        data: customer_graph_data,
        fill: true,

        backgroundColor: 'rgba(5, 195, 221, 0.2)',
        borderColor: 'rgb(5, 195, 221)',
        //pointBorderColor: 'rgb(5, 195, 221)',
        //pointBackgroundColor: 'rgb(5, 195, 221)',

        yAxisID: 'y-axis-1',
        xAxisID: 'x-axis-1',
      },
    ];

    setCustomerGraphData({labels: customer_graph_labels, datasets: customer_graph_datasets});

    setIsLoading(false);
  }

  useEffect(() => {
    fetchCustomerStats(token);
  }, [token])


  return (
    <>
      <Typography color="primary" variant="h1">
        Your Customer Signups
      </Typography><br/>

      <Typography color="primary" variant="h2">
        Total: {customerStats['total']}
      </Typography><br/>

      {isLoading &&
        <Grid container spacing={3}>
          <Grid xs={12} style={{'textAlign': 'center'}}>
            <img src={loading_gif} style={{'width': '150px'}}/>
          </Grid>
        </Grid>
      }

      {!isLoading &&
        <>
          <div style={{'height': '150px'}}>
            <Bar data={customerGraphData} options={plot_options} resizeDelay={0}/>
          </div>
          {_.map(customerStats['per_date'], (count, date) => {
            return (
              <div
                style={{'borderRadius': '20px', 'marginBottom': '20px', 'backgroundColor': 'white', 'padding': '10px'}}>
                {date}: {count}
              </div>
            )
          })}
        </>
      }
    </>
  )
}

export default CustomerStats
